import { CSSProperties, ReactNode } from 'react';
import clsx from 'clsx';
import { useTheme } from '@src/theme';

export const InfoCard = ({
    icon,
    title,
    metrics,
    value,
    color,
    style,
}: {
    icon?: ReactNode;
    title: string;
    value: string | number;
    color?: string;
    metrics?: { label: string; value: string | number }[];
    style?: CSSProperties;
}) => {
    const { theme } = useTheme();
    return (
        <div
            className="flex items-center rounded-xl border shadow-sm w-full h-24"
            style={style}
        >
            <div
                className={clsx('w-30 md:w-44 flex justify-start pl-4 h-full', {
                    'border-r border-r-secondary-light': metrics?.length,
                })}
            >
                <div
                    className="flex flex-col justify-center gap-2"
                    style={{ color: theme.semantic.textPrimary }}
                >
                    <div className="text-R-16 whitespace-nowrap">{title}</div>
                    <div
                        className={clsx(
                            'flex items-center gap-2 text-base font-medium',
                            color
                        )}
                    >
                        {icon}
                        {value}
                    </div>
                </div>
            </div>
            <div className="flex w-full px-4 justify-between">
                {metrics?.map((metric, idx) => (
                    <div
                        key={idx}
                        className="flex flex-col gap-2"
                        style={{ color: theme.semantic.textPrimary }}
                    >
                        <span className="text-R-14">{metric.label}</span>
                        <span className="text-M-20">{metric.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
